import React from 'react';
import AllRoute from '../router';
import { AuthProvider } from '../../context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../i18n'; // Import i18n configuration

const App = () => {
  return (
    <div className="App" id='scrool'>
      <AuthProvider>
        <AllRoute />
        <ToastContainer position="bottom-right" autoClose={2500} theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;